module.exports = __webpack_public_path__ + "assets/360d25ac64295e984420a5058f585283.mp3";